'use client';

import { Box, Typography } from '@mui/material';

interface AddSegmentButtonProps {
  onClick: () => void;
}

export function AddSegmentButton({ onClick }: AddSegmentButtonProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        px: '12px',
        py: '8px',
        borderRadius: '4px',
        border: '1px dashed',
        borderColor: 'divider',
        color: 'text.secondary',
        cursor: 'pointer',
        '&:hover': {
          borderColor: 'primary.main',
          color: 'primary.main',
          bgcolor: 'action.hover',
        },
      }}
    >
      <i className='material-symbols-add-rounded text-sm' />
      <Typography variant='body2' sx={{ fontSize: '0.75rem' }}>
        Add Segment
      </Typography>
    </Box>
  );
}
